<template>
    <template v-if="action && vertical && dialogOpen">
        <VettingChangeRedirectDialog v-if="isRedirectDialog" @cancel="dialogOpen = false" @confirm="onDialogConfirm" />
        <DialogWithReason
            v-else-if="!isRefuseSilently"
            :action="action"
            :vertical="vertical"
            :warnings="warnings"
            @cancel="dialogOpen = false"
            @confirm="onDialogConfirm"
        />
        <SimpleDialog v-else-if="isRefuseSilently" :action="action" :vertical="vertical" @cancel="dialogOpen = false" @confirm="onDialogConfirm" />
    </template>
</template>

<script setup lang="ts">
    import {onMounted, onUnmounted, computed, ref} from 'vue';
    import {FreelancerVertical} from '@api';
    import {eventBus} from '~/config/events';
    import {DialogAction} from './Dialog.model';
    import DialogWithReason from './DialogWithReason.vue';
    import SimpleDialog from './SimpleDialog.vue';
    import VettingChangeRedirectDialog from './VettingChangeRedirectDialog.vue';

    const vertical = ref<FreelancerVertical>();
    const action = ref<DialogAction>();
    const warnings = ref<string[]>([]);
    const dialogOpen = ref<boolean>(false);
    const isRefuseSilently = ref<boolean>(false);

    onMounted(() => {
        eventBus.on('verticalRefuseToStrategy:open', () => {
            openDialog({
                action: DialogAction.Refuse,
                vertical: FreelancerVertical.Strategy,
            });
        });
        eventBus.on('verticalSuggestToStrategy:open', (warningsForStrategy) =>
            openDialog({
                action: DialogAction.Apply,
                vertical: FreelancerVertical.Strategy,
                warnings: warningsForStrategy,
            }),
        );
        eventBus.on('verticalRefuseSilentlyToStrategy:open', () => {
            openDialog(
                {
                    action: DialogAction.Refuse,
                    vertical: FreelancerVertical.Strategy,
                },
                true,
            );
        });
        eventBus.on('verticalAcceptToRegular:open', () =>
            openDialog({
                action: DialogAction.Accept,
                vertical: FreelancerVertical.Regular,
            }),
        );
    });

    onUnmounted(() => {
        eventBus.off('verticalRefuseToStrategy:open');
        eventBus.off('verticalSuggestToStrategy:open');
        eventBus.off('verticalRefuseSilentlyToStrategy:open');
        eventBus.off('verticalAcceptToRegular:open');
    });

    const isRedirectDialog = computed(
        () => action.value === DialogAction.Refuse && vertical.value === FreelancerVertical.Strategy && !isRefuseSilently.value,
    );

    function openDialog(value: {action: DialogAction; vertical: FreelancerVertical; warnings?: string[]}, isRefuseSilentlyToStrategy?: boolean) {
        action.value = value.action;
        vertical.value = value.vertical;
        warnings.value = value.warnings ?? [];
        dialogOpen.value = true;
        isRefuseSilently.value = isRefuseSilentlyToStrategy ?? false;
    }

    function onDialogConfirm() {
        dialogOpen.value = false;
    }
</script>
